import { i18n } from 'i18n'
import { heicKey, MAX_RAW_IMAGE_SIZE_MB } from 'util/image'

export type UserErrorType =
  | 'unknown'
  | 'cant_take_photo'
  | 'bad_selfie'
  | 'upload_failed'
  | 'unsupported_image_type'
  | 'too_large_file'
  | 'corrupted_file'

export class SilentError extends Error {
  constructor() {
    super()
  }
}

export class UserError extends Error {
  readonly type: UserErrorType

  constructor(type: UserErrorType) {
    super(type)
    this.type = type
  }
}

export type FullError = {
  title: string
  desc: string
  tips?: boolean
}

export function getFullError(type: UserErrorType): FullError {
  switch (type) {
    case 'cant_take_photo':
      return {
        title: i18n('error.cant_take_photo.title'),
        desc: i18n('error.cant_take_photo.desc'),
      }
    case 'bad_selfie':
      return {
        title: i18n('error.bad_selfie.title'),
        desc: i18n('error.bad_selfie.desc'),
        tips: true,
      }
    case 'upload_failed':
      return {
        title: i18n('error.upload_failed.title'),
        desc: i18n('error.upload_failed.desc'),
      }
    case 'unsupported_image_type':
      return {
        title: i18n('error.unsupported_image_type.title'),
        desc: i18n(heicKey('error.unsupported_image_type.desc')),
      }
    case 'too_large_file':
      return {
        title: i18n('error.too_large_file.title', { mb: MAX_RAW_IMAGE_SIZE_MB }),
        desc: i18n('error.too_large_file.desc', { mb: MAX_RAW_IMAGE_SIZE_MB }),
      }
    case 'corrupted_file':
      return {
        title: i18n('error.corrupted_file.title'),
        desc: i18n(heicKey('error.corrupted_file.desc')),
      }
    case 'unknown':
    default:
      if (type !== 'unknown') console.error('unknown error type', type)
      return {
        title: i18n('error.unknown.title'),
        desc: i18n('error.unknown.desc'),
      }
  }
}
